export enum Services
{
    FireStopping = '1',
    FireDoors = '2',
    FireCompartmentation = '3',
    VehicleCheck = '5',
    HealthAndSafety = '6',
}

export const ServiceLabels: Record<Services, string> = {
    [Services.FireStopping]: 'Fire Stopping',
    [Services.FireDoors]: 'Fire Doors',
    [Services.FireCompartmentation]: 'Fire Compartmentation',
    [Services.VehicleCheck]: 'Vehicle Check',
    [Services.HealthAndSafety]: 'Health & Safety',
};

export const PreWorkServices: ReadonlySet<string> = new Set([
    Services.VehicleCheck,
    Services.HealthAndSafety,
]);

export function isPreWorkServiceId(serviceId: Services | string | number | null | undefined): boolean
{
    return serviceId !== null && serviceId !== undefined && PreWorkServices.has(String(serviceId));
}
